import React from 'react';
import HrnbLink from '../controls/HrnbLink';
import '../../css/components/TagBadge.css';

/**
 * Бейдж тега — кликабельный элемент тега
 * @param {Object} props
 * @param {Object} props.tag - Объект тега { id, name, slug, postCount }
 * @param {string} [props.variant='default'] - Стиль бейджа
 * @param {boolean} [props.active=false] - Активный статус
 * @param {Function} [props.onClick] - Обработчик клика
 */
export default function TagBadge({ tag, variant = 'default', active = false, onClick }) {
    const tagSlug = tag.slug || tag.name?.toLowerCase().replace(/\s+/g, '-');
    const tagName = typeof tag === 'string' ? tag : (tag.name || 'тег');

    const handleClick = (e) => {
        e.stopPropagation();
        if (onClick) {
            e.preventDefault();
            onClick(tag);
        }
    };

    return (
        <HrnbLink
            to={`/forum/tags/${tagSlug}`}
            className={`tag-badge tag-badge-${variant} ${active ? 'tag-badge-active' : ''}`}
            onClick={handleClick}
            title={`Посты с тегом #${tagName}`}
        >
            #{tagName}
            {tag.postCount !== undefined && (
                <span className="tag-badge-count">{tag.postCount}</span>
            )}
        </HrnbLink>
    );
}
